import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { coinbaseWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets';
import { createConfig, http } from 'wagmi';
import * as chains from 'wagmi/chains';

import { ALCHEMY_KEY, WC_PROJECT_ID, WC_PROJECT_NAME } from './common.config';

const ALCHEMY_MAINNET = `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_KEY}`;
const ALCHEMY_SEPOLIA = `https://eth-sepolia.g.alchemy.com/v2/${ALCHEMY_KEY}`;

export const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [walletConnectWallet, coinbaseWallet],
    },
  ],
  {
    appName: WC_PROJECT_NAME,
    projectId: WC_PROJECT_ID,
  },
);

export const wagmiConfig = createConfig({
  connectors,
  chains: Object.values(chains) as any,
  transports: Object.fromEntries(
    Object.values(chains).map(chain => [
      chain.id,
      http(chain.id === chains.mainnet.id ? ALCHEMY_MAINNET : chains.sepolia.id === chain.id ? ALCHEMY_SEPOLIA : ''),
    ]),
  ),
});
